"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var pinStyles_1 = require("./pinStyles");
var MapPin_1 = require("../../../../assets/svg/MapPin");
var clsx_1 = require("clsx");
var Tooltip_1 = require("../tooltip/Tooltip");
var core_1 = require("@material-ui/core");
var Pin = function (_a) {
    var _b, _c;
    var onClick = _a.onClick, index = _a.index, _d = _a.selected, selected = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, tooltipContent = _a.tooltipContent;
    var styles = pinStyles_1.default();
    var disableClick = disabled || selected;
    return (<core_1.Box data-test="dealer:pinContainer" data-test-is-selected={selected} data-test-is-disabled={disabled}>
      {selected ? <Tooltip_1.default> {tooltipContent} </Tooltip_1.default> : null}
      <div className={clsx_1.default([
        styles.pinContainer,
        (_b = {}, _b[styles.selected] = selected, _b),
        (_c = {}, _c[styles.disabled] = disabled && !selected, _c),
    ])} onClick={function () { return !disableClick && onClick(); }} data-test={"dealer:pin_" + index}>
        <MapPin_1.default />
        <div className={styles.indexContainer}>
          <core_1.Typography variant="body2">{index}</core_1.Typography>
        </div>
      </div>
    </core_1.Box>);
};
exports.default = Pin;
